export class LoadSportEventDefinitionAction {
  static readonly type = '[SportEventDefinition] LoadSportEventDefinitionAction';

  constructor(public sportId: string) {}
}
export class ResetSportEventDefinitionAction {
  static readonly type = '[SportEventDefinition] ResertSportEventDefinitionAction';
}

export class LoadSportEventDefinitionsAction {
  static readonly type = '[SportEventDefinition] LoadSportEventDefinitionsAction';
}
